import axios from 'axios';
import { confirm } from '../components/ConfirmDialog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolves true (show), false (hide) or null (cancelled).
export const askShowDiscount = async () => {
  const res = await confirm({
    title: 'Show discount on the PDF?',
    message: 'If hidden, the PDF shows only the final discounted prices, with no discount column or discount line.',
    confirmText: 'Show discount',
    altText: 'Hide discount',
    cancelText: 'Cancel',
    danger: false,
  });
  if (res === 'alt') return false;
  return res === true ? true : null;
};

const fmtDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// Asks show/hide discount, then builds the Gmail/Outlook/WhatsApp message.
export const buildQuoteSharePayload = async (quotation) => {
  const show = await askShowDiscount();
  if (show === null) return null;
  const { data } = await axios.post(`${BACKEND_URL}/api/quotations/${quotation.id}/generate-share-link`);
  const pdfUrl = `${BACKEND_URL}/api/share/${data.share_token}?show_discount=${show}`;
  const org = data.customer_name || quotation.lead_name;
  const greeting = data.contact_name ? `Dear ${data.contact_name} (${org}),` : `Dear ${org} team,`;
  const validity = data.valid_until ? `\nValid until: ${fmtDate(data.valid_until)}` : '';
  return {
    subject: `Quotation for ${org}`,
    body: `${greeting}\n\nPlease find our quotation for ${org}.\n\nTotal: ₹${Number(quotation.total || 0).toLocaleString('en-IN')}${validity}\n\nView / download the quotation PDF here:\n${pdfUrl}\n\nBest regards,`,
  };
};
